import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { DeliveryBullets } from './components/DeliveryBullets';
import { TrustMetrics } from './components/TrustMetrics';
import { ShortTestimonials } from './components/ShortTestimonials';
import { PainPoints } from './components/PainPoints';
import { ProductPresentation } from './components/ProductPresentation';
import { Tomos } from './components/Tomos';
import { Bonuses } from './components/Bonuses';
import { Urgency } from './components/Urgency';
import { PricingCards } from './components/PricingCards';
import { Comparison } from './components/Comparison';
import { PremiumModules } from './components/PremiumModules';
import { LongTestimonials } from './components/LongTestimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { Closing } from './components/Closing';
import { CostTable } from './components/CostTable';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  useEffect(() => {
    // Meta Pixel
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window,document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1468583271333005');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=1468583271333005&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.body.appendChild(noscript);
    return () => {
      document.head.removeChild(script);
      document.body.removeChild(noscript);
    };
  }, []);
  return <div className="w-full min-h-screen relative bg-[#0A0A0A] text-white overflow-hidden" data-id="element-0">
      <SocialProofPopup data-id="element-1" />
      <div className="fixed inset-0 pointer-events-none z-0" style={{
      background: 'radial-gradient(ellipse at center, rgba(212, 168, 67, 0.35) 0%, rgba(212, 168, 67, 0.15) 35%, rgba(212, 168, 67, 0.04) 55%, rgba(10, 10, 10, 0) 80%)'
    }} data-id="element-2" />
      <div className="relative z-10" data-id="element-3">
        <Hero data-id="element-4" />
        <DeliveryBullets data-id="element-5" />
        <TrustMetrics data-id="element-6" />
        <ShortTestimonials data-id="element-7" />
        <PainPoints data-id="element-8" />
        <ProductPresentation data-id="element-9" />
        <Tomos data-id="element-10" />
        <Bonuses data-id="element-11" />
        <Urgency data-id="element-12" />
        <PricingCards data-id="element-13" />
        <Comparison data-id="element-14" />
        <PremiumModules data-id="element-15" />
        <LongTestimonials data-id="element-16" />
        <Guarantee data-id="element-17" />
        <FAQ data-id="element-18" />
        <Closing data-id="element-19" />
        <CostTable data-id="element-20" />
        <FinalCTA data-id="element-21" />
        <Footer data-id="element-22" />
      </div>
    </div>;
}